module.exports = __webpack_public_path__ + "img/septentrions.1c41ea15.png";